import axios from "axios";
import qs from "qs";

const { API_BACKEND_HOST } = process.env;
const responseFormat = { error: "", data: null };

export const listFolders = async (depth, path) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Slot/SupportMaterial/listFolders`,
      {
        params: {
          ...(depth && { depth }),
          ...(path && { prefix: path }),
        },
      }
    );

    responseFormat.data = response.data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar listar pastas";

    return responseFormat;
  }
};

export const createFolder = async (path) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/FileManager/CreateFolder`,
      {},
      {
        params: {
          folderName: path,
        },
      }
    );

    responseFormat.data = response.data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = response.data.errors || "Erro ao tentar criar pasta";

    return responseFormat;
  }
};

export const listFiles = async (params) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/FileManager/GetFiles`,
      params
    );

    responseFormat.data = response.data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar listar arquivos";

    return responseFormat;
  }
};

export const listFileById = async (id) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/FileManager/GetFile/${id}`
    );

    responseFormat.data = response.data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar listar arquivos";

    return responseFormat;
  }
};

export const listFilesByMeetId = async (meetId) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/FileManager/GetFilesByMeetId/${meetId}`
    );

    responseFormat.data = response.data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar listar arquivos";

    return responseFormat;
  }
};

export const listFilesBySlotCommitteeId = async (slotCommitteeId) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/FileManager/GetFilesBySlotComittee/${slotCommitteeId}`
    );

    responseFormat.data = response.data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar listar arquivos";

    return responseFormat;
  }
};

export const searchFiles = async (params) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/FileManager/SearchFiles`,
      {
        params,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      }
    );

    responseFormat.data = response.data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar listar arquivos";

    return responseFormat;
  }
};

export const uploadFiles = async (formData, path) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/FileManager/upload`,
      formData,
      {
        params: {
          path,
        },
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );

    responseFormat.data = response.data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response?.data?.errors || "Erro ao tentar listar arquivos";
    responseFormat.data = false;

    return responseFormat;
  }
};

export const deleteLogicallySlot = async (id) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios({
      method: "DELETE",
      url: `${API_BACKEND_HOST}${languageId}/v1/FileManager/logically/${id}`,
    });
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar deletar o(s) arquivo(s)";
    return responseFormat;
  }
};

export const deletePhisicallySlot = async (id) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const response = await axios({
      method: "DELETE",
      url: `${API_BACKEND_HOST}${languageId}/v1/FileManager/phisically/${id}`,
    });
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar deletar o(s) arquivo(s)";
    return responseFormat;
  }
};

export const downloadFile = async (id, fileName) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios({
      method: "GET",
      url: `${API_BACKEND_HOST}${languageId}/v1/FileManager/download/${id}`,
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);

    document.body.appendChild(link);

    link.click();

    responseFormat.data = response;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data?.errors?.length > 0
        ? response.data.errors.join(", ")
        : "Erro ao realizar download";
    return responseFormat;
  }
};

export const getFileBlob = async (id) => {
  const languageId = localStorage.getItem("i18nextLng");

  const nonBlobResponse = await axios({
    method: "GET",
    url: `${API_BACKEND_HOST}${languageId}/v1/FileManager/download/${id}`,
  });

  const response = await axios({
    method: "GET",
    url: `${API_BACKEND_HOST}${languageId}/v1/FileManager/download/${id}`,
    responseType: "blob",
  });

  console.log(nonBlobResponse.headers);

  return response;
};
